import { Grid, TextField, Typography, MenuItem, useTheme } from '@mui/material';
import { Field } from 'formik';

interface LockerEquipmentConfigProps {
  mode: 'create' | 'edit';
  isSubmitting: boolean;
  errors: any;
  touched: any;
  loadingData: boolean;
  equipments: any[];
  manufacturers: any[];
  rooms: any[];
}

export function LockerEquipmentConfig({
  mode,
  isSubmitting,
  errors,
  touched,
  loadingData,
  equipments,
  manufacturers,
  rooms,
}: LockerEquipmentConfigProps) {
  const theme = useTheme();

  return (
    <>
      <Grid item xs={12}>
        <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2} mt={2}>
          Equipamentos e Configurações
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Field
          as={TextField}
          select
          fullWidth
          label="Equipamento"
          name="equipmentId"
          required
          disabled={isSubmitting || loadingData || mode === 'edit'}
          error={!!(touched.equipmentId && errors.equipmentId)}
          helperText={mode === 'edit' ? 'Equipamento não pode ser alterado' : (touched.equipmentId && errors.equipmentId)}
        >
          {loadingData ? (
            <MenuItem disabled>Carregando equipamentos...</MenuItem>
          ) : (
            equipments.map((equipment: any) => (
              <MenuItem key={equipment.id} value={equipment.id}>
                {equipment.name}
              </MenuItem>
            ))
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Field
          as={TextField}
          select
          fullWidth
          label="Fabricante"
          name="manufacturerId"
          required
          disabled={isSubmitting || loadingData || mode === 'edit'}
          error={!!(touched.manufacturerId && errors.manufacturerId)}
          helperText={mode === 'edit' ? 'Fabricante não pode ser alterado' : (touched.manufacturerId && errors.manufacturerId)}
        >
          {loadingData ? (
            <MenuItem disabled>Carregando fabricantes...</MenuItem>
          ) : (
            manufacturers.map((manufacturer: any) => (
              <MenuItem key={manufacturer.id} value={manufacturer.id}>
                {manufacturer.name}
              </MenuItem>
            ))
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Field
          as={TextField}
          select
          fullWidth
          label="Área"
          name="roomId"
          required
          disabled={isSubmitting || loadingData || mode === 'edit'}
          error={!!(touched.roomId && errors.roomId)}
          helperText={mode === 'edit' ? 'Área não pode ser alterada' : (touched.roomId && errors.roomId)}
        >
          {loadingData ? (
            <MenuItem disabled>Carregando áreas...</MenuItem>
          ) : (
            rooms.map((room: any) => (
              <MenuItem key={room.id} value={room.id}>
                {room.name}
              </MenuItem>
            ))
          )}
        </Field>
      </Grid>
    </>
  );
} 